/** Даты по Еревану (UTC+4, без перехода на летнее время) для выбора слотов */
const OFFSET = 4 * 3600_000;

export function yerevanDateKey(d: Date): string {
  return new Date(d.getTime() + OFFSET).toISOString().slice(0, 10);
}

/** Ключи следующих n дней, начиная с сегодня по Еревану */
export function nextDays(n: number, from = new Date()): string[] {
  const out: string[] = [];
  for (let i = 0; i < n; i++) out.push(yerevanDateKey(new Date(from.getTime() + i * 86_400_000)));
  return out;
}

/** Полдень дня — чтобы форматировать дату без сдвига */
export const dateKeyToDate = (key: string) => new Date(`${key}T12:00:00+04:00`);
